import Training from '../../training';

/**
 * Create the action
 */

const { thunk, request, success, error } = Training.index((fetch) => {
    return fetch.get(`/trainings`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
